import {
  registerLanguage,
  initCulture,
  setCultureOrder,
  setLanguage,
  setLanguageOrder,
} from 'skybase-ui/skybase-core/locales/actions'

import { getDetectedLanguage } from 'skybase-ui/skybase-core/locales/utils'

import config from '@/config'

// Here is where you link all of the other translations that you will need
// For example: import skybaseAuthTranslations from 'skybase-auth/languages/languages.json'
import skybaseOauthTranslations from 'skybase-oauth/languages/languages'
import skybaseUiTranslations from 'skybase-ui/languages/languages'
import localTranslations from '@/languages/languages'
import { batchActions } from 'redux-batched-actions'

if (!Intl.RelativeTimeFormat) {
  /* eslint-disable global-require */
  require('@formatjs/intl-relativetimeformat/polyfill')
  require('@formatjs/intl-relativetimeformat/dist/locale-data/en')
  require('@formatjs/intl-relativetimeformat/dist/locale-data/de')
  require('@formatjs/intl-relativetimeformat/dist/locale-data/es')
  require('@formatjs/intl-relativetimeformat/dist/locale-data/zh')
  require('@formatjs/intl-relativetimeformat/dist/locale-data/vi')
  require('@formatjs/intl-relativetimeformat/dist/locale-data/ko')
  require('@formatjs/intl-relativetimeformat/dist/locale-data/ru')
  /* eslint-enable global-require */
}

export const initializeLanguagesAndCulture = dispatch => {
  const translations = []
  config.languages.forEach(key => {
    translations.push(
      registerLanguage(key, {
        ...skybaseOauthTranslations[key],
        ...skybaseUiTranslations[key],
        ...localTranslations[key],
      }),
    )
  })

  // Try to determine an actual user's locale:
  // First check if locale was . If not, do browser locale detection.
  const detectedLanguage = getDetectedLanguage(config.languages)
  dispatch(
    batchActions([
      ...translations,
      setLanguageOrder(config.languages),
      setLanguage(detectedLanguage),
      setCultureOrder(config.cultures),
      initCulture(),
    ]),
  )
}
